/**
 * @module experience/shared-experience
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
//  import { SETTINGS, CHANNELS } from '@environment/settings';

export class ChannelSegmentModel {
  private salesChannelCode: string;
  private salesSubChannelCode: string;
  private subChannelCategory: string;

  constructor() {
    // if (SETTINGS.CHANNEL.toLowerCase() === CHANNELS.RETAIL) {
    //     this.salesChannelCode = 'In-Person';
    //     this.salesSubChannelCode = 'Full Service';
    //     this.subChannelCategory = 'T-MobileRetail';
    // }
    // else if (SETTINGS.CHANNEL.toLowerCase() === CHANNELS.CARE) {
    //     this.salesChannelCode = 'Over the Phone';
    //     this.salesSubChannelCode = 'Care';
    //     this.subChannelCategory = 'Frontline';
    // }
    // else {
    this.salesChannelCode = 'APP';
    this.salesSubChannelCode = 'Web';
    this.subChannelCategory = '';
    // }
  }
}
